export default {
  init() {
      // JavaScript to be fired on all pages
      var $hamburger = $('.hamburger');
      $hamburger.on('click', function() {
          $hamburger.toggleClass('is-active');

          // Do something else, like open/close menu
      });

      /*eslint-disable */
      $('.btn-play').click(function(ev) {
          ev.preventDefault();
          console.log('click btn video');
          $(this).css('display','none');
          $('.bg-yt').css('display','none');
          player.playVideo();
      });

      //console.log(document.getElementsByClassName('btn-play')[0]);

      //document.getElementsByClassName('btn-play')[0].addEventListener('click', function(ev) {
        // ev.preventDefault();
        //console.log('click btn video 2');
        // $(this).css('display','none');
        // $('.bg-yt').css('display','none');
        // player.playVideo();
      //});

      function CheckIE() {

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        var browserName;

        if(isIE) {
            browserName = 'iexplorer'
            $('.main').addClass(browserName);
        }else if(isEdge) {
            browserName = 'edge'
            $('.main').addClass(browserName);
        }
      }

      CheckIE();

    /*
    function externalLinks() {
        for(var c = document.getElementsByTagName('a'), a = 0;a < c.length;a++) {
        var b = c[a];
        b.getAttribute('href') && b.hostname !== location.hostname && (b.target = '_blank')
        }
    }
    
    
    externalLinks();
    */

      if($('.single-memorial-wrapper').length > 0) {
          $('.owl-carousel').owlCarousel({
              'items': 1,
              'nav' : true,
              'navText' : ['<i class="fas fa-caret-left"></i>', '<i class="fas fa-caret-right"></i>'],
          });
      }

      if($('#galleryOutfitters').length > 0) {
          var carousel = $('.owl-carousel').owlCarousel({
              items: 1,
              nav : true,
              navText : ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
              animateOut : 'fadeOut',
              autoplay: false,
          });

          $('.open-modal').click(function() {
              var index = $(this).attr('class').split(' ')[1].split('-')[1];
              carousel.trigger('to.owl.carousel', [index-1, 300]);
          });
      }

      $('.share-btn-wrap').click(function() {
          $(this).next('.social-media-share').addClass('show');
      });

      $(document).mouseup(function(e)
      {
          var container = $('.social-media-share');
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
              $('.social-media-share').removeClass('show');
          }
      });

      $(document).ready( function() {

          var itemSelector = '.grid-item';

          var $container = $('#container').isotope({
              itemSelector: itemSelector,
              layoutMode: 'masonryHorizontal',
              masonryHorizontal: {
                  rowHeight: 26,
              },
              getSortData: {
                  name: '.list-name',
              },
              sortBy : 'name',
          });

          //Ascending order
          var responsiveIsotope = [
              [480, 48],
              [768, 48],
              [992, 48],
          ];

          var itemsPerPageDefault = 48;
          var itemsPerPage = defineItemsPerPage();
          var currentNumberPages = 1;
          var currentPage = 1;
          var currentFilter = '*';
          var currentFilterTab = '0-tab';
          var filterAtribute = 'data-filter';
          var filterAtributeTab = 'data-tab';
          var show_in_all_attr = 'data-all';
          var current_show_in_all = 'yes';
          var pageAtribute = 'data-page';
          var pagerClass = 'isotope-pager';

          function changeFilter(selector) {
              $container.isotope({
                  filter: selector,
              });
          }


          function goToPage(n) {
              currentPage = n;

              var selector = itemSelector;
              selector += ( current_show_in_all == 'yes' ) ? '['+show_in_all_attr+'="'+current_show_in_all+'"]' : '';
              selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
              selector += ( currentFilterTab != '*' ) ? '['+filterAtributeTab+'="'+currentFilterTab+'"]' : '';
              selector += '['+pageAtribute+'="'+currentPage+'"]';

              console.log(selector);
              changeFilter(selector);
          }

          function defineItemsPerPage() {
              var pages = itemsPerPageDefault;

              for( var i = 0; i < responsiveIsotope.length; i++ ) {
                  if( $(window).width() <= responsiveIsotope[i][0] ) {
                      pages = responsiveIsotope[i][1];
                      break;
                  }
              }

              return pages;
          }

          function setPagination() {

              console.log(currentFilter);
              console.log(currentFilterTab);
              /*var itemsLength = $container.children(itemSelector).length;

              var pages = Math.ceil(itemsLength / itemsPerPage);*/
              var item = 1;
              var page = 1;
              var selector = itemSelector;
              selector += ( current_show_in_all == 'yes' ) ? '['+show_in_all_attr+'="'+current_show_in_all+'"]' : '';
              selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
              selector += ( currentFilterTab != '*' ) ? '['+filterAtributeTab+'="'+currentFilterTab+'"]' : '';

              $container.children(selector).each(function(){
                  if( item > itemsPerPage ) {
                      page++;
                      item = 1;
                  }
                  $(this).attr(pageAtribute, page);
                  item++;
              });

              currentNumberPages = page;


              var $isotopePager = ( $('.'+pagerClass).length == 0 ) ? $('<div class="'+pagerClass+'"></div>') : $('.'+pagerClass);

              $isotopePager.html('');

              for( var i = 0; i < currentNumberPages; i++ ) {
                  var $pager = $('<a href="javascript:void(0);" class="pager" '+pageAtribute+'="'+(i+1)+'"></a>');
                  $pager.html(i+1);

                  $pager.click(function(){
                      $('.isotope-pager .pager').removeClass('active');
                      $(this).addClass('active');
                      var page = $(this).eq(0).attr(pageAtribute);
                      goToPage(page);
                  });

                  $pager.appendTo($isotopePager);
              }

              $container.after($isotopePager);

          }

          setPagination();
          goToPage(1);

          //Adicionando Event de Click para as categorias
          $('.filters a').click(function(){
              $('.filters a').removeClass('active');
              $(this).addClass('active');
              var filter = $(this).attr(filterAtribute);
              currentFilter = filter;
              if(filter === '*') {
                  $('#dropdownYear.'+currentFilterTab).text('All');
              }else {
                  $('#dropdownYear.'+currentFilterTab).text(filter);
              }

              current_show_in_all = $(this).attr(show_in_all_attr);

              setPagination();
              goToPage(1);

          });

          $('.filters-tab a').click(function(){
              $('#dropdownYear.'+currentFilterTab).text('All');
              var filterTab = $(this).attr(filterAtributeTab);
              var open = $(this).attr('data-open');

              $('.content-head').removeClass('active');
              $('.filters-tab a').removeClass('active');
              $(this).addClass('active');
              $('.content-head.head-'+open).addClass('active');

              currentFilterTab = filterTab;
              currentFilter = '*';
              current_show_in_all = 'yes';

              setPagination();
              goToPage(1);

          });

          //Evento Responsivo
          $(window).resize(function(){
              itemsPerPage = defineItemsPerPage();
              setPagination();
              goToPage(1);
          });

          /* section add link story */
          var albumitem = $('.ngg-album-compact');
          $.each(albumitem, function () {
              var namealbum = $(this).find('h4 a').text().replace(/\s+/g, '-').toLowerCase();
              /* eslint-disable */
              var linkstory = window.location.protocol + "//" + window.location.hostname  + "/stories/" + namealbum.replace(/'/g, "");

              // var linkElement = '<br>';
              // if(!$(this).find('h4 a').hasClass('hide')) {
              var linkElement = '<a href="'+linkstory+'">'+ $(this).find('h4 a').text() +'</a>';
              // }

              var link_el = '<div class="text-center pt-2 pb-2">' + linkElement + '</div>';
              $(this).append(link_el);
              // console.log(link_el);
              $(this).find('.ngg-album-link a').attr('href', linkstory)
              $(this).find('h4').addClass('d-none');
          })

          $('.ngg-galleryoverview').siblings('.comment-respond').css({
              'display' : 'block',
          });

      });
          },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js